import React from "react";
import { Icon } from "./Icon.jsx";

/* Status badge / pill. tone: positive | negative | warning | info | neutral | brand.
   Sentence-case status text (Settled, Pending, In review, Failed). */
const TONES = {
  positive: { bg: "#E6FBEF", fg: "#1B8553", dot: "var(--green-success)" },
  negative: { bg: "var(--red-soft)", fg: "#C0392B", dot: "var(--red)" },
  warning:  { bg: "var(--amber-soft)", fg: "#B45309", dot: "var(--orange)" },
  info:     { bg: "#E8F1FE", fg: "#1A5FC4", dot: "var(--blue-info)" },
  brand:    { bg: "var(--mint-light)", fg: "#1B8553", dot: "var(--green-bright)" },
  neutral:  { bg: "var(--grey-bg)", fg: "var(--text-muted)", dot: "var(--grey-mid)" },
};

export function Badge({ children, tone = "neutral", dot = false, icon, size = "md", style, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  const sm = size === "sm";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        height: sm ? 20 : 24,
        padding: sm ? "0 8px" : "0 10px",
        borderRadius: "var(--radius-pill)",
        background: t.bg,
        color: t.fg,
        fontFamily: "var(--font-sans)",
        fontWeight: 600,
        fontSize: sm ? 11 : 12,
        lineHeight: 1,
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
        ...style,
      }}
      {...rest}
    >
      {dot ? (
        <span style={{ width: 7, height: 7, borderRadius: "50%", background: t.dot, flex: "none" }} />
      ) : null}
      {icon ? <Icon name={icon} size={sm ? 12 : 14} /> : null}
      {children}
    </span>
  );
}

export default Badge;
